"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIResultsMessage;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var RenderProp = _interopRequireWildcard(require("../utils/propTypes/renderProp"));

var _createLazyPropType = _interopRequireDefault(require("../utils/propTypes/createLazyPropType"));

var _H = _interopRequireDefault(require("../elements/headings/H2"));

var _lazyEval = _interopRequireDefault(require("../utils/lazyEval"));

var _UIIllustration = _interopRequireDefault(require("../image/UIIllustration"));

var _UISection = _interopRequireDefault(require("../section/UISection"));

var _illustrationName = require("../utils/propTypes/illustrationName");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  margin-bottom: 40px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  text-align: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var MessageOuter = (0, _styledComponents.default)(_UISection.default).withConfig({
  displayName: "UIResultsMessage__MessageOuter",
  componentId: "qmydks-0"
})(_templateObject());
var MessageImage = (0, _styledComponents.default)(_UIIllustration.default).withConfig({
  displayName: "UIResultsMessage__MessageImage",
  componentId: "qmydks-1"
})(_templateObject2());
var defaultIllustrationProps = {
  width: 175
};

var renderTitle = function renderTitle(title) {
  if (!title) return null;
  if (_react.default.isValidElement(title)) return title;
  return _react.default.createElement(_H.default, null, (0, _lazyEval.default)(title));
};

var renderImage = function renderImage(illustration, illustrationProps, Image) {
  if (!illustration && !Image) return null;
  return _react.default.createElement(Image, (0, _extends2.default)({
    name: illustration
  }, defaultIllustrationProps, illustrationProps));
};

function UIResultsMessage(props) {
  var Body = props.Body,
      children = props.children,
      illustration = props.illustration,
      illustrationProps = props.illustrationProps,
      Image = props.Image,
      title = props.title,
      rest = (0, _objectWithoutProperties2.default)(props, ["Body", "children", "illustration", "illustrationProps", "Image", "title"]);
  return _react.default.createElement(MessageOuter, (0, _extends2.default)({}, rest, {
    role: "alert",
    use: "island"
  }), renderImage(illustration, illustrationProps, Image), renderTitle(title), _react.default.createElement(Body, null, children));
}

UIResultsMessage.propTypes = {
  Body: _propTypes.default.elementType,
  children: _propTypes.default.node,
  illustration: (0, _illustrationName.getIllustrationNamePropType)(),
  illustrationProps: _propTypes.default.object,
  Image: RenderProp.getPropType(_UIIllustration.default),
  title: (0, _createLazyPropType.default)(_propTypes.default.node)
};
UIResultsMessage.defaultProps = {
  Body: 'div',
  Image: MessageImage,
  illustrationProps: defaultIllustrationProps
};
UIResultsMessage.displayName = 'UIResultsMessage';
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/results/UIResultsMessage.js
// module id = 761
// module chunks = 5 6